import React from 'react';

const Footer = function(){
  return (
      <div className="cmp-footer">
        <div className="container">
          <div className="logo-container">
            <img src='https://static.retail.autofact.cl/img/logo-blanco.svg' className="img-fluid" alt="Logo Autofact"/>
          </div>
        </div>
      </div>
  )
};

export default Footer;
